export default __webpack_public_path__ + "static/media/kitchen-1940174_640.2a02cea4.jpg";